<div class="header flex justify-between items-start">
  <div mat-dialog-title class="title flex flex-col">
    <span class="caption" data-test-id="schedule-edit-dialog-caption">
      Edit time
    </span>
    <h3 data-test-id="schedule-edit-dialog-title">
      {{ block.date | date: 'EEEE d MMMM' }}
    </h3>
  </div>
  <button
    class="close-button"
    mat-icon-button
    mat-dialog-close
    title="Close"
    data-test-id="schedule-edit-dialog-close-button"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <app-timezone-input
    testId="schedule-edit-dialog-timezone"
    required
    [(timezone)]="timezoneName"
  />
  <app-schedule-times-fields [controls]="form.controls">
    @let skippedTimesError = getSkippedTimesError();
    @if (skippedTimesError) {
      <mat-error
        class="form-error inset"
        data-test-id="schedule-edit-dialog-skipped-error"
      >
        {{ skippedTimesError }}
      </mat-error>
    }
  </app-schedule-times-fields>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    class="delete-button"
    mat-button
    type="button"
    data-test-id="schedule-edit-dialog-delete-button"
    (click)="delete()"
  >
    <mat-icon>delete_outline</mat-icon>
    Delete
  </button>
  <button
    class="cancel-button"
    mat-button
    type="button"
    mat-dialog-close
    data-test-id="schedule-edit-dialog-cancel-button"
  >
    Cancel
  </button>
  <button
    class="save-button"
    mat-flat-button
    type="button"
    color="primary"
    data-test-id="schedule-edit-dialog-save-button"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
